module.exports = __webpack_public_path__ + "static/resume.354a5e25.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/resume.pdf
// module id = 398
// module chunks = 114276838955818